import React from 'react';
import PropTypes from 'prop-types';
import s from './inputWraper.module.scss';
import cx from 'clsx';

const InputWraper = ({ children, label, error, errorMessage, onClick, className, isActive, isFocused, small, big }) => {
    const styleWrapper = cx(s.wrapper, className, small && s.small, big && s.big);

    const styleItem = cx(
        s.item,
        isFocused && s['item--focused'],
        isActive && s['item--active'],
        error && s['item--error'],
    );

    return (
        <div className={styleWrapper} onClick={onClick}>
            {small && label && <p className={s.label_small}>{label}</p>}
            <div className={styleItem}>
                {children}
                {!small && <span className={s.label}>{label}</span>}
            </div>
            {error && <p className={s.message}>{errorMessage}</p>}
        </div>
    );
};

InputWraper.propTypes = {
    children: PropTypes.element,
    label: PropTypes.string,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    isActive: PropTypes.any,
    isFocused: PropTypes.bool,
    small: PropTypes.bool,
    big: PropTypes.bool,
};

export default React.memo(InputWraper);
